import { EditIcon, DeleteIcon, AddIcon } from '@chakra-ui/icons'
import { Box, Flex, Button, Divider } from '@chakra-ui/react'
import {
  MDXEditorMethods,
  MDXEditor,
  listsPlugin,
  linkPlugin,
  linkDialogPlugin,
  toolbarPlugin,
  UndoRedo,
  BoldItalicUnderlineToggles,
  CreateLink
} from '@mdxeditor/editor'
import { useState, useRef } from 'react'
import ReactMarkdown from 'react-markdown'
import { SystemFormHeading } from './systemForm.support'
export interface systemNotesInterface {
  notes: string
}

export const SystemNotes = ({
  input,
  onChangeCallBack
}: {
  input: systemNotesInterface[]
  onChangeCallBack: (data: systemNotesInterface[]) => void
}): JSX.Element => {
  const [notesList, setNotesList] = useState<systemNotesInterface[]>(input)
  const [editIndex, setEditIndex] = useState<number | null>(null)
  const editNote = (index: number): void => {
    setEditIndex(index)
  }
  const deleteNote = (index: number): void => {
    const updatedNotes = notesList.filter((_, i) => i !== index)
    onChangeCallBack(updatedNotes)
    setNotesList(updatedNotes)
  }
  const updateNote = (index: number): void => {
    const markdown = mdxRef.current?.getMarkdown() ?? ''
    const updatedNotes = notesList.map((item, i) => (i === index ? { notes: markdown } : item))
    setNotesList(updatedNotes)
    setEditIndex(null)
    onChangeCallBack(updatedNotes)
  }
  const addNote = (): void => {
    setEditIndex(notesList.length)
    setNotesList([...notesList, { notes: '' }])
  }
  const mdxRef = useRef<MDXEditorMethods>(null)

  return (
    <>
      <SystemFormHeading title="Notes" />

      {notesList.map(({ notes }, index) => (
        <Box key={`${notes}_systemNotes`}>
          {index !== editIndex && (
            <Box bg="gray.50" mx="2" p="4">
              <ReactMarkdown>{notes}</ReactMarkdown>
            </Box>
          )}

          {index === editIndex && (
            <Box bg="gray.50" p="2" mb="2">
              <MDXEditor
                contentEditableClassName="snap-MDX-editor"
                markdown={notes}
                ref={mdxRef}
                autoFocus
                plugins={[
                  listsPlugin(),
                  linkPlugin(),
                  linkDialogPlugin(),
                  toolbarPlugin({
                    toolbarContents: () => (
                      <>
                        <UndoRedo /> <BoldItalicUnderlineToggles /> <CreateLink />
                      </>
                    )
                  })
                ]}
              />
            </Box>
          )}
          <Flex justifyContent="space-between" mx="2">
            {editIndex === index && (
              <>
                <Button onClick={() => updateNote(index)} colorScheme={'green'}>
                  Save
                </Button>
                <Button onClick={() => setEditIndex(null)}>Cancel</Button>
              </>
            )}
            {editIndex !== index && (
              <>
                <Button onClick={() => editNote(index)}>
                  <EditIcon />
                </Button>
                <Button onClick={() => deleteNote(index)} title="delete" bg="red.600" color="white">
                  <DeleteIcon />
                </Button>
              </>
            )}
          </Flex>
          <Divider mt="4" />
        </Box>
      ))}
      <Button mt="4" onClick={addNote} bg="purple.700" colorScheme={'purple'} color="white">
        <AddIcon boxSize={3} mr="2" />
        Add Note
      </Button>
    </>
  )
}
